import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PageMeta from '../components/home/PageMeta';
import HeroSection from '../components/home/HeroSection';
import ClientLogosSection from '../components/home/ClientLogosSection';
import SuccessStoriesSection from '../components/home/SuccessStoriesSection';
import ProcessSection from '../components/home/ProcessSection';
import ContactOfficeSection from '../components/home/ContactOfficeSection';

/** Scroll to section when arriving from /#process etc. */
const useHomeHashScroll = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) {
      setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    }
  }, [hash]);
};

const HomePage = () => {
  useHomeHashScroll();

  return (
    <div className="landing-page">
      <PageMeta
        title="Hype CRO"
        description="Tıklamaları gelire çeviren modern optimizasyon. Veriye dayalı CRO ve A/B test çözümleri."
      />
      <HeroSection />
      <ClientLogosSection />
      <SuccessStoriesSection />
      <ProcessSection />
      <ContactOfficeSection />
    </div>
  );
};

export default HomePage;
